import { OnInit, Component, OnDestroy, Input } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-ventanilla-espera-UAC',
    templateUrl: './ventanilla-espera-UAC.component.html',
    styleUrls: ['./atender-ciudadano-UAC.component.scss']
})

export class VentanillaEsperaUACComponent implements OnInit, OnDestroy {
    public modalOptions: ConfirmationModalOptions;
    public motivoEspera: any;
    public listaMotivosEspera: any;
    private subscription: Subscription[];
    @Input() numeroVentanilla: any;
    @Input() sede: any;
    constructor(
          private alertService: AlertService, private activeModal: NgbActiveModal
        , private urlService: UrlService, private global: GlobalService, private spiner: NgxSpinnerService) {

        this.subscription = [];
        this.modalOptions = new ConfirmationModalOptions('Confirmaciòn', '¿Está seguro de suspender atención en esta ventanilla?', 'SI', 'NO', 'fas fa-ban', true, null, 'Suspender Atención', null, 'btn btn-secondary');
        this.motivoEspera = null;
        this.listaMotivosEspera = [];
    }


    ngOnInit() {
        this.consultarMotivosVentanillaEspera();
    }
    /**
     * 
     */
    close() {
        this.activeModal.close();
    }

    /**
     * consulta el dominio de motivos de espera de una ventanilla
     * @author fromero
     */
    consultarMotivosVentanillaEspera() {
        this.spiner.show();
        const serviceProvider = 'ObtenerDominio';
        var queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'MotivoVentanillaEspera']);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        const sucripcion = this.global.getGenerico(url).subscribe(
            data => {
                this.listaMotivosEspera = data;
                this.spiner.hide();
            }, err => {
                this.cathException('Error Consultando Motivos de espera');
            }
        );
        this.subscription.push(sucripcion);
    }

    /**
     * metodo que realiza la petición de actualización de estado ventanilla
     * @author fromero
     * @param event 
     */
    ventanillaEspera(event) {
        if (event[0]) {
            this.spiner.show();
            const serviceProvider = 'ventanillaEspera';
            var queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['numeroVentanilla', this.numeroVentanilla]);
            queryParams.push(['motivoEspera', this.motivoEspera]);
            queryParams.push(['sede', this.sede]);
            queryParams.push(['estado', 'ESP']);
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
            const sucripcion = this.global.getGenerico(url).subscribe(
                data => {
                    this.alertService.generateAlertSuccess(data.mensaje, '');
                    this.activeModal.close(true);
                    this.spiner.hide();
                }, err => {
                    this.cathException(err.error.message);
                }
            );
            this.subscription.push(sucripcion);
        }
    }

    /**
     * @author fromero
     * activa el boton de cambio de estado cuando el motivo es diligenciado
     */
    setMotivo() {
        this.modalOptions.disabled = false;
    }

    /**
    * 
    * @param error 
    */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spiner.hide();
    }

    /**
     * destruye las subscripciones del componente 
     * 
     */
    ngOnDestroy() {
        this.subscription.forEach(el => {
            el.unsubscribe();
        })
    }

}